import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(private http: HttpClient) {}

  getSamlStatus() {
    const url = 'saml2_auth/configure_status';
    return this.http.get(url);
  }

  getSamlConfiguration() {
    const url = 'saml2_auth/configure_saml';
    return this.http.get(url);
  }

  saveOrUpdateSamlConfigration(data: any) {
    const url = 'saml2_auth/configure_saml';
    return this.http.post(url, data);
  }

  deactivateSSO(data: any) {
    const url = 'saml2_auth/configure_saml';
    return this.http.put(url, data);
  }

  loginSso() {
    const url = 'saml2_auth/login';
    return this.http.get(url);
  }

  getCeleryTask(){
    const url = '/solution_app/task'
    return this.http.get(url);
  }
}
